import React, { useState, useCallback } from "react";
import { useSelector } from "react-redux";
import { selectMeasurePoints } from 'redux/locationsSlice';
import { LocationMeasurePointCard, LocationSearchFilters } from "components";
import { Grid, Stack } from "@mui/material";

export default function LocationGroupsCardView(props) {
    const locations = useSelector(selectMeasurePoints);
    const [searchValue, setSearchValue] = useState(null);
    const [searchAttractionTypes, setSearchAttractionTypes] = useState([]);
    const [searchTourismTypes, setSearchTourismTypes] = useState([]);
    const [tourismMethod, setTourismMethod] = useState("some");
    const [searchAccessibilityOptions, setSearchAccessibilityOptions] = useState([]);
    const [accessibilityMethod, setAccessibilityMethod] = useState("some");

    const filterHandler = useCallback((type, data) => {
        switch (type) {
            case 'search':
                setSearchValue(data);
                break;
            case 'attraction':
                setSearchAttractionTypes(data);
                break;
            case 'tourism':
                setSearchTourismTypes(data);
                break;
            case 'tourismMethod':
                setTourismMethod(data);
                break;
            case 'accessibility':
                setSearchAccessibilityOptions(data);
                break;
            case 'accessibilityMethod':
                setAccessibilityMethod(data);
                break;
            default:
                setSearchValue(null);
                setSearchTourismTypes([]);
                setTourismMethod("some");
                setSearchAccessibilityOptions([]);
                setAccessibilityMethod("some");
                break;
        }
    }, [setSearchValue, setSearchAttractionTypes, setSearchTourismTypes, setTourismMethod, setSearchAccessibilityOptions, setAccessibilityMethod]);

    return <Stack direction="column" spacing={0.5} sx={{ width: '100%' }}>
        <LocationSearchFilters searchValue={searchValue} attractionValues={searchAttractionTypes} tourismValues={searchTourismTypes} tourismMethod={tourismMethod} accessibilityValues={searchAccessibilityOptions} accessibilityMethod={accessibilityMethod} filterHandler={filterHandler} />
        <Grid container direction="row" spacing={2}>
            {
                locations
                    .filter(location => searchValue === null ? true : location.name.includes(searchValue))
                    .filter(location => !searchAttractionTypes.length ? true : searchAttractionTypes.includes(location.touristAttraction.attractionType))
                    .filter(location => !searchTourismTypes.length ? true
                        : location.touristAttraction.tourismTypes.length ? searchTourismTypes.map(t => t.key)[tourismMethod](el => location.touristAttraction.tourismTypes.includes(el)) : false
                    )
                    .filter(location => !searchAccessibilityOptions.length ? true
                        : location.touristAttraction.accessibilityOptions.length ? searchAccessibilityOptions.map(t => t.key)[accessibilityMethod](el => location.touristAttraction.accessibilityOptions.includes(el)) : false
                    )
                    .map((location) => {
                        return <Grid key={location.name} item xs={12} sm={12} md={6} lg={4} sx={{ display: 'flex', pl: '0 !important', pr: 2 }}>
                            <LocationMeasurePointCard location={location} />
                        </Grid>
                    })
            }
        </Grid>
    </Stack>;
}